'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { Typo3Image } from '@/types'
import { BaseLink, Richtext, Time, Title } from '@/ui/components'
import { BaseLinkProps } from '@/ui/components/Base/type'
import { generateAltText } from '@/utils'
import { MEDIA } from '@spot'
import { memo, useMemo } from 'react'
import Img from '../Img/Img'

interface CardStoryProps extends React.HTMLAttributes<HTMLAnchorElement> {
  title?: string
  image?: Typo3Image
  link?: BaseLinkProps
  date?: string
  text?: string
  subTitle?: string
}

const CardStory = ({
  title,
  image,
  link,
  text,
  date,
  subTitle,
  className,
  ...props
}: CardStoryProps) => {
  //const D = useStoreI18n.use.dictionary()
  const currentLocale = useStoreI18n.use.currentLocale()

  const imageAlt = useMemo(
    () => generateAltText('story', title, text, currentLocale),
    [title, text, currentLocale]
  )

  return (
    <BaseLink
      {...link}
      fallback={'div'}
      nextLink={true}
      className="c-card-story w-full"
      {...props}
    >
      <div className={cn('group relative text-neutral-600', className)}>
        <div className="relative">
          {image && (
            <Img
              data={image}
              alt={imageAlt}
              objectCover
              crop={{
                width: 442,
                height: 248
              }}
              fill
              className="aspect-square"
              hoverGroupEffect
              sizes={`${MEDIA.tablet} 45rem`}
              quality={90}
            />
          )}
        </div>

        <div className={'py-sm'}>
          <div className="gap-y-sm flex flex-col">
            <Time date={date} />
            <Title as="h3" className={'h4 line-clamp-3'}>
              {title}
            </Title>
            <div className="textstyle-md-regular line-clamp-3">
              <Richtext text={text} />
            </div>
          </div>
        </div>
      </div>
    </BaseLink>
  )
}

CardStory.displayName = 'CardStory'

export default memo(CardStory)
